import { render, staticRenderFns } from "./cargoEnglishWordsInput.vue?vue&type=template&id=0fae9d46&"
import script from "./cargoEnglishWordsInput.vue?vue&type=script&lang=js&"
export * from "./cargoEnglishWordsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fae9d46')) {
      api.createRecord('0fae9d46', component.options)
    } else {
      api.reload('0fae9d46', component.options)
    }
    module.hot.accept("./cargoEnglishWordsInput.vue?vue&type=template&id=0fae9d46&", function () {
      api.rerender('0fae9d46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoEnglishWordsInput.vue"
export default component.exports